import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useLocation } from 'react-router-dom';
import api from '../../utils/api';

function MockBanner() {
  const [mode, setMode] = useState(null);
  useEffect(() => {
    api.get('/integration-mode').then(res => setMode(res.data.mode)).catch(() => {});
  }, []);
  if (mode !== 'mock') return null;
  return <div className="mock-banner">Running in Mock Mode — No emails will be sent</div>;
}

export default function Layout({ children }) {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setNavOpen(false);
  }, [location]);

  return (
    <div className="app">
      <Sidebar isOpen={navOpen} onClose={() => setNavOpen(false)} />
      <div className="main">
        <MockBanner />
        <Topbar onBurgerClick={() => setNavOpen(o => !o)} />
        <div style={{ flex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
}
